const homeChildren = [
  {
    path: "/fourIndex",
    name: "fourIndex",
    component: () => import("@/pages/home/fourIndex"),
    meta: {
      title: "首页"
    }
  },
  {
    path: "/monitoringData",
    name: "monitoringData",
    component: () => import("@/pages/monitoringData/index"),
    meta: {
      title: "监测数据"
    },
    children: [
      {
        path: "fodderView",
        name: "fodderView",
        component: () => import("@/pages/monitoringData/fodderView"),
        meta: {
          title: "饲料监测"
        }
      },
      {
        path: "importedView",
        name: "importedView",
        component: () => import("@/pages/monitoringData/importedView"),
        meta: {
          title: "进口监测"
        }
      },
      {
        path: "priceView",
        name: "priceView",
        component: () => import("@/pages/monitoringData/priceView"),
        meta: {
          title: "价格监测"
        }
      },
      {
        path: "prodCapacityView",
        name: "prodCapacityView",
        component: () => import("@/pages/monitoringData/prodCapacityView"),
        meta: {
          title: "产能监测"
        }
      }
    ]
  },
  {
    path: "/dayNews",
    name: "dayNews",
    component: () => import("@/pages/dayNews/index"),
    meta: {
      title: "每日猪讯"
    }
  },
  {
    path: "/aboutUs",
    name: "aboutUs",
    component: () => import("@/pages/about/aboutUs"),
    meta: {
      title: "关于我们"
    }
  },
  {
    path: "/dayPrice",
    name: "dayPrice",
    component: () => import("@/pages/dayPrice/index"),
    meta: {
      title: "今日猪价"
    }
  },
  {
    path: "/IndProd",
    name: "IndProd",
    component: () => import("@/pages/IndProd/index"),
    meta: {
      title: "产业指数"
    }
  },
  {
    path: "/noticeList",
    name: "noticeList",
    component: () => import("@/pages/notice/noticeList"),
    meta: {
      title: "公示公告"
    },
  },
  {
    path: "/noticeList/noticeDetails",
    name: "noticeDetails",
    component: () => import("@/pages/notice/noticeDetails"),
    meta: {
      title: "公告详情"
    }
  }
];
export default homeChildren;



// WEBPACK FOOTER //
// ./src/router/children/home.js